import { useLayoutEffect, useState } from "react";
import BerryIcon from "../../components/BerryIcon";
import logoUrl from "../../assets/berry_mail_logo.svg";

// Si el redirect automático no dispara por algún motivo (bloqueador de
// extensión, etc.), mostramos la tarjeta como fallback manual en vez de
// dejar la pantalla en blanco para siempre.
const REDIRECT_STALL_MS = 1500;

export default function LoginPage() {
  const [showFallback, setShowFallback] = useState(false);

  useLayoutEffect(() => {
    // Salta el click de "Continuar con BerryKey": mismo patrón que
    // "Iniciar sesión con Google" — el salto de dominio es inevitable (es el
    // punto del flujo), pero no hace falta un click intermedio para
    // dispararlo. useLayoutEffect (no useEffect) corre antes de que el
    // navegador pinte, así la navegación pasa sin que la tarjeta llegue a
    // mostrarse — con useEffect se veía un parpadeo de la tarjeta completa.
    window.location.href = "/auth/login";
    const timer = setTimeout(() => setShowFallback(true), REDIRECT_STALL_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!showFallback) {
    return <div style={{ minHeight: "100vh", background: "var(--surface-1)" }} />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface-1)",
        fontFamily: "var(--font-body)",
      }}
    >
      <div
        style={{
          width: 340,
          // Mismo tratamiento que el sidebar (--sidebar-bg, fijo — no sigue
          // el tema claro/oscuro): el logo completo (más abajo) viene con
          // el wordmark en blanco, pensado para este fondo.
          background: "var(--sidebar-bg)",
          borderRadius: 12,
          padding: "32px 28px",
          textAlign: "center",
        }}
      >
        <BerryIcon size={48} />
        {/* Logo completo (wordmark + isotipo propio) debajo del isotipo de
            BerryLoo — dos marcas distintas apiladas, no una redundante con
            la otra (src/assets/berry_mail_logo.svg). */}
        <img
          src={logoUrl}
          alt="BerryLoo Mail"
          style={{ height: 26, width: "auto", margin: "14px 0 4px" }}
        />
        <p style={{ fontSize: 13, color: "var(--sidebar-text-muted)", margin: "0 0 28px" }}>
          Accede con tu cuenta BerryKey
        </p>

        <a
          href="/auth/login"
          style={{
            width: "100%",
            height: 44,
            background: "var(--color-primary)",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            marginBottom: 12,
            textDecoration: "none",
            boxSizing: "border-box",
          }}
        >
          Continuar con BerryKey
        </a>

        <p style={{ fontSize: 11, color: "var(--sidebar-text-muted)", lineHeight: 1.6, margin: "16px 0 0" }}>
          El mismo acceso que usas para BerryLoo Cloud y el resto de servicios BerryLoo.
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 20,
            paddingTop: 16,
            borderTop: "0.5px solid rgba(255,255,255,0.15)",
          }}
        >
          <p style={{ fontSize: 11, color: "var(--sidebar-text-muted)", margin: 0, textAlign: "left" }}>
            Tu contraseña nunca llega a BerryLoo Mail — se valida directamente con BerryKey.
          </p>
        </div>
      </div>
    </div>
  );
}
